// extracted by mini-css-extract-plugin
export default {"youtubeContainer":"Youtube_youtubeContainer__X-hqr","ytIframe":"Youtube_ytIframe__-q0SS"};